import React from 'react';
import PropTypes from 'prop-types';
import './Toggle.css';

const Toggle = ({ checked = false, onChange, disabled }) => {
  const handleClick = () => {
    if (!disabled) {
      onChange();
    }
  };

  return (
    <button onClick={handleClick} className={`max-w-[63px] w-full h-[31px] cursor-pointer justify-between items-center rounded-[100px] ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'} ${ checked ? 'bg-[#419066] flex flex-reverse pl-2 pr-2' : 'bg-[#D54043] flex flex-row-reverse pl-2 pr-2'}`}>
      <p className='font-bebas text-base text-[#F2F2F2]'>{checked ? 'on' : 'off'}</p>
      <div className={`bg-light w-[19px] h-[19px] rounded-full ${checked ? 'animate-on' : 'animate-off'}`}></div>
    </button>
  );
};

Toggle.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

export default Toggle;
